// style
import './style/progress.css'

const Progress = (props: any) => {
    let items = ['احراز شماره موبایل', 'پیش ثبت نام', 'تایید اطلاعات اولیه', 'اطلاعات تکمیلی', 'صدور کد پذیرندگی']
    return (
        <>
            <section className={'container-fluid'}>
                <div className={'row justify-content-center'}>
                    <div className={'col-lg-8 col-12'}>
                        <div className="progressBar my-md-4 my-4 mb-md-5 mb-5">
                            <ul className="list-unstyled multi-steps px-0">
                                {items.map((item, index) => (
                                    <li key={item}
                                        data-aos={'fade-down'}
                                        data-aos-duration="1500"
                                        className={props.number === index ? 'is-progress font-medium fw-bold' : index < props.number ? 'is-active font-medium fw-bold' : 'font-medium fw-bold'}>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Progress